<template>
  <div class="wrapper-buttons d-flex">
    <button
      v-for="(button, i) in buttonsFiltered"
      :disabled="button.isDisabled"
      :key="i"
      type="button"
      :class="[button.class, {'ml-2' : i}]"
      class="btn text-center rounded-pill"
      @click="button.clickHandler"
      :title="button.title" 
    >
    
      <component :is="button.icon" :title="button.title" class="mb-1" />
   
    </button>
  </div>
</template>

<script>
export default {
  props: {
    selectedLength: {
      type: Number,
      default: 0,
    },
    hideCreate: {
      type: Boolean,
      default: false
    },
    // hideUpdate: {
    //   type: Boolean,
    //   default: false
    // },
    hideDelete: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      actionButtons: [
        // {
        //   class: "btn-info",
        //   title: "Editar",
        //   icon: "pencil-icon",
        //   action: 'update',
        //   min: 1,
        //   max: 1
        // },
        {
          class: "btn-danger",
          title: "Deletar",
          icon: "delete-icon",
          action: 'delete',
          min: 1,
          max: null
        },
        {
          class: "btn-3v3",
          title: "Adicionar",
          icon: "plus-icon",
          action: 'add',
          min: null,
          max: null
        },
      ]
    }
  },
  computed: {
    buttonsLockings() {
      return [
        this.hideUpdate,
        this.hideDelete,
        this.hideCreate,
      ]
    },
    buttonsWithActions() {
      return this.actionButtons.map(button => {
        button.clickHandler = () => this.handleAction(button.action);

        return button;
      }).map(button => {
        button.isDisabled = this.isDisabled(button);

        if(button.isDisabled) {
          button.clickHandler = () => {};
        }

        return button;
      });
    },
    buttonsFiltered() {
      return this.buttonsWithActions.filter((item, i) => {
        return !this.buttonsLockings[i];
      })
    },
  },
  methods: {
    handleAction(action) {
      this.$emit(action);
    },
    isDisabled(button) {
      const hasMin = button.min;
      const hasMax = button.max;
      const outMin = hasMin ? this.selectedLength < button.min : false;
      const outMax = hasMax ? this.selectedLength > button.max : false;

      if(!outMin && !outMax) {
        return false;
      }

      return true;
    },
  }
}
</script>

<style scoped>
.wrapper-buttons {
  --distance-button: 34px;
  position: fixed;
  bottom: var(--distance-button);
  right: var(--distance-button);
  z-index: 100;
}

@media (max-width: 768px) {
  .wrapper-buttons {
    --distance-button: var(--size-bars);
    --right-distance-button: 22px;
    --bottom-distance-button: calc(var(--side-nav-icon-height) + 20px);
  }
}

button {
  --size-action-button: 37.6px;
  height: var(--size-action-button);
  width: var(--size-action-button);
}

button,
button * {
  font-size: 1rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>